module.exports = __webpack_public_path__ + "img/banner8.143a3820.jpg";